/// <amd-module name="typeahead/features/ShowEssOnFocusPersonalizedSuggestions" />

import {EssDataProvider} from "typeahead/core/EssDataProvider";
import {Experiment} from "typeahead/core/Experiment";
import {IDataProvider} from "typeahead/core/IDataProvider";
import {IDataProviderResponse} from "typeahead/core/IDataProvider";
import {IExperimentalFeature} from "typeahead/core/IExperimentalFeature";
import {IFocusSuggester} from "typeahead/core/IFocusSuggester";
import {IListItem} from "typeahead/core/IListItem";
import {ISuggesterResponse} from "typeahead/core/ISuggester";
import * as ExecutionHelper from "typeahead/core/plugins/ExecutionHelper";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";
import * as StripingConfiguration from "typeahead/core/StripingConfiguration";
import {SuggesterId} from "typeahead/core/SuggestionsAggregator";

const configuration: IStripingConfiguration[] = [
    {
        clients: ["Homepage", "AWSHomepage", "FlightsLandingPage", "CarsLandingPage", "HotelsLandingPage"],
        tabs: ["flight", "hotel", "car", "activity", "package", "packageFlightHotel", "packageFlightHotelCar",
            "packageFlightCar", "packageHotelCar", "flightHotel", "flightHotelCar", "flightCar", "hotelCar",
            "carHotel", "carHotelFlight", "carFlight"],
    },
    {
        clients: ["Hotels.Search", "Flights.Search", "Cars.Search", "LX.Search", "LXLandingPage",
            "PackageLandingPage"],
    },
];

export class ShowEssOnFocusPersonalizedSuggestions implements IFocusSuggester, IExperimentalFeature {
    private dataProvider: IDataProvider = new EssDataProvider();

    public getId(): SuggesterId {
        return SuggesterId.EssOnFocusPersonalizedSuggester;
    }

    public suggest(options: any, context: IContext): JQueryPromise<ISuggesterResponse> {
        let deferred: JQueryDeferred<ISuggesterResponse> = $.Deferred();
        if (ExecutionHelper.shouldExecute(context, configuration)) {
            this.fetchSuggestionsAndResolve(deferred, options, context);
        } else {
            this.resolve(deferred, []);
        }
        return deferred.promise();
    }

    public getExperiments(): Experiment[] {
        return StripingConfiguration.getExperiments(configuration);
    }

    public suggestOnFocus(options: any, context: IContext) {
        return this.suggest(options, context);
    }

    private resolve(deferred: JQueryDeferred<ISuggesterResponse>, suggestions: IListItem[]): void {
        deferred.resolve({
            id: this.getId(),
            results: suggestions,
        });
    }

    private fetchSuggestionsAndResolve(
            deferred: JQueryDeferred<ISuggesterResponse>,
            options: any,
            context: IContext): void {
        let suggestions: IListItem[] = [];

        this.dataProvider
            .fetchData($.extend(true, {}, options, {context}, {personalize: true}))
            .then((response: IDataProviderResponse) => {
                if (response && response.results) {
                    suggestions = suggestions.concat(response.results);
                }
            })
            .always(() => {
                this.resolve(deferred, suggestions);
            });
    }
}
